import { motion } from "framer-motion";
import { Handshake, Clock, Wallet, MessageSquareHeart } from "lucide-react";

const reasons = [
  {
    icon: Handshake,
    title: "Direkter Draht",
    desc: "Du sprichst nicht mit einem Vertriebler — sondern mit mir. Persönlich. Vom ersten Call bis zum Launch.",
  },
  {
    icon: Clock,
    title: "Schnelle Reaktion",
    desc: "Ich melde mich innerhalb von 24 Stunden — meistens schneller. Im Wartungs-Abo sogar mit Priorität.",
  },
  {
    icon: Wallet,
    title: "Faire Festpreise",
    desc: "Kein Stundenchaos. Du weißt vorher, was Deine Website kostet. Keine versteckten Posten.",
  },
  {
    icon: MessageSquareHeart,
    title: "Langfristig persönlich",
    desc: "Ich kenne Dein Business, Deine Seite und Deine Ziele — und das auch noch in drei Jahren.",
  },
];

export default function WhyUs() {
  return (
    <section data-testid="why-section" className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-10 items-start mb-14">
          <div className="md:col-span-5">
            <div className="text-xs uppercase tracking-[0.25em] text-zinc-500 font-semibold">
              Warum mit mir arbeiten
            </div>
            <h2 className="font-display text-4xl sm:text-5xl font-light tracking-tight text-zinc-900 mt-4">
              Vier Gründe, <span className="italic">die zählen.</span>
            </h2>
          </div>
          <p className="md:col-span-7 md:col-start-7 text-zinc-500 leading-relaxed">
            Große Agenturen sind teuer und langsam. Bei mir bekommst Du
            Wandel-Geschwindigkeit, persönlichen Kontakt und faire Preise — vom
            ersten Konzept bis Jahre nach dem Launch.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {reasons.map((r, i) => {
            const Icon = r.icon;
            return (
              <motion.div
                key={r.title}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                data-testid={`why-reason-${i}`}
                className="bg-zinc-50/60 border border-zinc-100 rounded-3xl p-7 hover:bg-white hover:border-zinc-200 hover:-translate-y-1 transition-all duration-300"
              >
                <div className="w-11 h-11 rounded-2xl bg-zinc-900 text-white flex items-center justify-center">
                  <Icon size={18} strokeWidth={1.5} />
                </div>
                <h3 className="font-display text-lg font-medium text-zinc-900 mt-5">{r.title}</h3>
                <p className="text-sm text-zinc-500 mt-2 leading-relaxed">{r.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
